import { State as ListState, reducer as listReducer } from "features/catalogue/reducers/product/list";
import { State as EditState, reducer as editReducer } from "features/catalogue/reducers/product/edit";
import { combineReducers } from "redux";

export interface State {
    menuItems: {
        list: ListState;
        edit: EditState;
    };
}

export const reducer = combineReducers({
    list: listReducer,
    edit: editReducer,
});
